import React from 'react'
import { useAuth0 } from '@auth0/auth0-react';

const Howitworks = () =>{
    function goToCalendly(e){
        e.preventDefault();
        window.location.href = 'https://calendly.com/sethmichaelking'
    }
    const { loginWithRedirect } = useAuth0();

  return (
    <div className='px-4'>
        <section class="bg-white dark:bg-gray-900">
            <div class="py-8 px-4 mx-auto max-w-screen-xl">
                    <h2 class="mb-4 text-4xl text-center tracking-tight font-extrabold text-gray-900 dark:text-white">How our service works</h2>
                <div class="space-y-8 md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-12 md:space-y-0">
                    <div style={{
                            textAlign: '-webkit-center'
                    }}>
                    <div class="m-3 flex h-10 w-10 items-center text-white justify-center rounded-full bg-black">
                        <p> 1</p>
                    </div>
                        <h3 class="mb-2 text-xl font-bold dark:text-white"> Research </h3>
                        <p class="text-gray-500 dark:text-gray-400">Tell us about your industry and expertise so GPT-3.5 can match you against inquiries based on your profile.</p>
                    </div>
                    <div style={{
                            textAlign: '-webkit-center'
                    }}>
                         <div class="m-3 flex h-10 w-10 items-center text-white justify-center rounded-full bg-black">
                        <p> 2</p>
                    </div>
                        <h3 class="mb-2 text-xl font-bold dark:text-white">Outreach</h3>
                        <p class="text-gray-500 dark:text-gray-400">Review your matches and reach out to journalists with why you'd be a good expert for the story.</p>
                    </div>
                    <div style={{
                            textAlign: '-webkit-center'
                    }}>
                    <div class="m-3 flex h-10 w-10 items-center text-white justify-center rounded-full bg-black">
                        <p> 3</p>
                    </div>
                        <h3 class="mb-2 text-xl font-bold dark:text-white">Results</h3>
                        <p class="text-gray-500 dark:text-gray-400">Get backlinks from trusted and respected publications in the form on quotes, interviews, breaking news and more. </p>
                    </div>
                </div>
            </div>
            <div className="flex justify-center mb-2">
                <button onClick={(e)=> goToCalendly(e)}type="button" class="text-white bg-gradient-to-r from-cyan-500 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">Schedule A Call</button>
            </div>
        </section>
        <div class="flex justify-center mb-4">
  <div class="flex flex-wrap gap-4 w-full md:w-1/2">
    {/* <!-- Card 1 --> */}
    <div class="flex-1 w-full md:w-1/2 flex flex-col justify-between p-4 border border-gray-300 rounded-lg shadow-md">
      <h5 class="mb-4 text-xl font-medium text-gray-500 dark:text-gray-400">Standard Plan</h5>
      <div class="flex items-baseline text-gray-900 dark:text-white">
        <span class="text-3xl font-semibold">$</span>
        <span class="text-5xl font-extrabold tracking-tight">25.99</span>
        <span class="ms-1 text-xl font-normal text-gray-500 dark:text-gray-400">/month</span>
      </div>
      <ul role="list" class="space-y-5 my-7 flex-grow">
        <li class="flex items-center">
          <svg class="flex-shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"></path>
          </svg>
          <span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">1 profile</span>
        </li>
        <li class="flex items-center">
          <svg class="flex-shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"></path>
          </svg>
          <span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">24/7 Monitoring</span>
        </li>
        <li class="flex items-center">
          <svg class="flex-shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"></path>
          </svg>
          <span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">SoS, Qwoted, HelpB2B, and others</span>
        </li>
        <li class="flex items-center">
          <svg class="flex-shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"></path>
          </svg>
          <span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">Daily Match Emails</span>
        </li>
        {/* <!-- Add the rest of the list items --> */}
      </ul>
      <button onClick={() => loginWithRedirect()} type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-200 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-900 font-medium rounded-lg text-sm px-5 py-2.5 inline-flex justify-center w-full text-center">
        Start Trial
      </button>
    </div>

    {/* <!-- Card 2 --> */}
    <div class="flex-1 w-full md:w-1/2 flex flex-col justify-between p-4 border border-gray-300 rounded-lg shadow-md">
      <h5 class="mb-4 text-xl font-medium text-gray-500 dark:text-gray-400">Agency Plan</h5>
      <div class="flex items-baseline text-gray-900 dark:text-white">
        <span class="text-3xl font-semibold">$</span>
        <span class="text-5xl font-extrabold tracking-tight">100</span>
        <span class="ms-1 text-xl font-normal text-gray-500 dark:text-gray-400">/month</span>
      </div>
      <ul role="list" class="space-y-5 my-7 flex-grow">
        <li class="flex items-center">
          <svg class="flex-shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"></path>
          </svg>
          <span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">Multiple Profiles</span>
        </li>
        <li class="flex items-center">
          <svg class="flex-shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"></path>
          </svg>
          <span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">Advanced matching</span>
        </li>
        <li class="flex items-center">
          <svg class="flex-shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"></path>
          </svg>
          <span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">Custom Integrations</span>
        </li>
        <li class="flex items-center">
          <svg class="flex-shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"></path>
          </svg>
          <span class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">Personalized Onboardings</span>
        </li>
        {/* <!-- Add the rest of the list items --> */}
      </ul>
      <button onClick={() => loginWithRedirect()} type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-200 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-900 font-medium rounded-lg text-sm px-5 py-2.5 inline-flex justify-center w-full text-center">
        Start Trial
      </button>
    </div>
  </div>
</div>

    </div>
  )
}

export default Howitworks